import Button from '@mui/material/Button';
import React from 'react';
import { ReactReduxContext } from 'react-redux';
import tinymce from 'tinymce';

import { assetsGet } from '@/selectors';
import State from '@/store/state';
import { Asset } from '@/store/types';
import { getReferenceText } from '@/components/SideBar/InsertIcon/InsertIcon.utils';

interface InsertIntoTemplateProps {
	assetId: Asset['id'];
}

const InsertIntoTemplate: React.FC<InsertIntoTemplateProps> = ({ assetId }) => {
	const { store } = React.useContext(ReactReduxContext);

	const onClick = React.useCallback(() => {
		const state: State = store.getState();
		const asset = assetsGet(state, assetId);
		const text = getReferenceText({ state, asset });
		tinymce.activeEditor.insertContent(text);
	}, [assetId, store]);

	return (
		<Button color="primary" fullWidth onClick={onClick} variant="outlined">
			Insert into template
		</Button>
	);
};

export default InsertIntoTemplate;
